import React from "react";
import {
    FinancePartnerDetailsResponse,
    ProductDetailsResponse,
} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {Table} from "antd";
import {renderPairItem} from "./OpportunityValidationShared";

interface ProductFinanceMethodsProps {
    product: ProductDetailsResponse;
    financePartner: FinancePartnerDetailsResponse;
}

export const ProductFinanceMethods: React.FC<ProductFinanceMethodsProps> = ({product, financePartner}) => {

    const columns = [
        {
            title: 'SFDC',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[0]),
        },
        {
            title: financePartner.financePartnerType,
            dataIndex: 'items',
            width: '70%',
            render: (value: any) => renderPairItem(value[1]),
        },
    ];

    const items = [
        {
            items: [
                {
                    name: 'Product Category',
                    value: product.sfdc.sfdcProductCategory,
                },
                {
                    name: 'Approved Products',
                    value: <Table
                        size={'small'}
                        pagination={false}
                        locale={{emptyText: null}}
                        columns={[
                            {
                                title: 'Product',
                                dataIndex: 'contract_Type',
                            },
                            {
                                title: 'Term',
                                dataIndex: 'term_Length',
                            },
                            {
                                title: 'APR',
                                dataIndex: 'apr',
                            },
                        ]}
                        dataSource={financePartner.financepartnerApprovedProducts ?? undefined}/>,
                },
            ],
        },
        {
            items: [
                {
                    name: 'Primary Finance Partner',
                    value: product.sfdc.sfdcPrimaryFinancePartner,
                },
                null,
            ],
        },
        {
            items: [
                {
                    name: 'Purchase Method',
                    value: product.sfdc.sfdcPurchaseMethod,
                },
                null,
            ],
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};